import { render, staticRenderFns } from "./footer-store.vue?vue&type=template&id=1f933d44&scoped=true"
import script from "./footer-store.vue?vue&type=script&lang=js"
export * from "./footer-store.vue?vue&type=script&lang=js"
import style0 from "./footer-store.vue?vue&type=style&index=0&id=1f933d44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f933d44",
  null
  
)

export default component.exports